var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaneTicketLarge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.117,
    height: 45.306,
    viewBox: "0 0 74.117 45.306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plane-ticket",
    transform: "translate(0 -126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40780",
    "data-name": "Path 40780",
    d: "M72.81,158.634a1.307,1.307,0,0,0-1.307,1.307V167.1a1.592,1.592,0,0,1-1.59,1.59H63.93a1.592,1.592,0,0,1-1.59-1.59v-3.05a1.307,1.307,0,0,0-2.614,0v3.05a1.592,1.592,0,0,1-1.59,1.59H4.2a1.592,1.592,0,0,1-1.59-1.59V130.2a1.592,1.592,0,0,1,1.59-1.59H9.466a1.307,1.307,0,1,0,0-2.614H4.2A4.209,4.209,0,0,0,0,130.2v36.9a4.209,4.209,0,0,0,4.2,4.2H58.136a4.19,4.19,0,0,0,2.9-1.16,4.189,4.189,0,0,0,2.9,1.16h5.983a4.209,4.209,0,0,0,4.2-4.2v-7.162A1.307,1.307,0,0,0,72.81,158.634Z",
    transform: "translate(0 0)",
    fill: "#230871"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40781",
    "data-name": "Path 40781",
    d: "M137.4,126H131.42a4.19,4.19,0,0,0-2.9,1.16,4.189,4.189,0,0,0-2.9-1.16H83.039a1.307,1.307,0,1,0,0,2.614h42.587a1.592,1.592,0,0,1,1.59,1.59v4.008a1.307,1.307,0,1,0,2.614,0V130.2a1.592,1.592,0,0,1,1.59-1.59H137.4a1.592,1.592,0,0,1,1.59,1.59v23.663a1.307,1.307,0,1,0,2.614,0V130.2A4.209,4.209,0,0,0,137.4,126Z",
    transform: "translate(-67.49 0)",
    fill: "#230871"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40782",
    "data-name": "Path 40782",
    d: "M342.75,273.642a1.307,1.307,0,0,0,2.614,0v-6.16a1.307,1.307,0,0,0-2.614,0Z",
    transform: "translate(-283.024 -115.749)",
    fill: "#230871"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40783",
    "data-name": "Path 40783",
    d: "M344.057,234.872c.722,0,1.307-2.628,1.307-5.868v-27.66c0-3.241-.585-5.868-1.307-5.868s-1.307,2.628-1.307,5.868V229C342.75,232.244,343.335,234.872,344.057,234.872Z",
    transform: "translate(-283.024 -65.844)",
    fill: "#230871"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40787",
    "data-name": "Path 40787",
    d: "M13.158,8.629H6.614L4.284,6.05a2.459,2.459,0,0,0-3.65,3.3L2.13,11,.721,12.412A2.459,2.459,0,1,0,4.2,15.889l2.342-2.342h6.618L9.415,18.168a2.459,2.459,0,1,0,3.822,3.1l6.25-7.717H24.7a2.459,2.459,0,1,0,0-4.919H19.488L13.238.911a2.459,2.459,0,0,0-3.822,3.1Z",
    transform: "translate(14.242 145.671) rotate(-30)",
    fill: "#230871"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneTicketLarge);
export default __webpack_public_path__ + "static/media/plane-ticket-large.a7602ad1.svg";
export { ForwardRef as ReactComponent };